<script setup lang="ts">
import { VueQueryDevtools } from "@tanstack/vue-query-devtools";
import { checkForExistingUtms } from "./utils/analytics";
import WarningBanner from "~/components/global/WarningBanner.vue";
const LazyLanding = defineAsyncComponent(
  () => import("./components/AdvertiserLanding/Landing.vue"),
);

const LazyLandingV2 = defineAsyncComponent(
  () => import("./components/AdvertiserLandingV2/index.vue"),
);

const route = useRoute();
const publicConfig = useRuntimeConfig().public;
const { $trpc } = useNuxtApp();

const brandName = ref<string | null>(null);
const brandNameLoading = ref(true);

function getVtidFromRoute() {
  if (typeof route.query?.vtid === "string") {
    return route.query.vtid;
  }
}

function onTrackerInit(trackerInitData: { deviceId: string }) {
  useAmplitudeStore().setDeviceId(trackerInitData.deviceId);
}

function initializeTracker() {
  // @ts-expect-error
  const tracker = window?.EvangelistTrackerComponent;
  if (tracker) {
    const vtid = getVtidFromRoute();
    tracker({ deviceId: vtid, onInit: onTrackerInit }).render("#evangelist-ut");
  }
}

function isEvangelistCoreDomain() {
  if (window.location.origin === publicConfig.CORE_SPA_DOMAIN) {
    return true;
  }

  return false;
}

async function getBrandNameForOrigin() {
  if (isEvangelistCoreDomain()) {
    return null;
  }

  try {
    const data = await $trpc.getBrandNameForHostname.query({
      hostname: window.location.hostname,
    });

    if (data && data.theme) {
      return data.theme;
    }
  } catch (error) {
    console.error("Error fetching brand name:", error);
  }

  return null;
}

onMounted(async () => {
  brandName.value = await getBrandNameForOrigin();
  brandNameLoading.value = false;
  initializeTracker();
});

useBodyFreeze();
useFixedFullscreen();

// make sure we save utm_ and invite_id to localStorage
checkForExistingUtms();
</script>
<template>
  <div>
    <div id="evangelist-ut" class="absolute w-[1px] h-[1px]"></div>
    <div v-if="!brandNameLoading" class="font-semibold">
      <!-- Uncomment for a global warning message across all pages, edit warning text in the component -->
      <!-- <WarningBanner /> -->

      <LazyLanding
        v-if="brandName === 'metaplex' || brandName === 'switchboard'"
        :brand-name="brandName"
      />

      <LazyLandingV2 v-else-if="brandName" :brand-name="brandName" />
      <NuxtLayout v-else>
        <NuxtPage />
      </NuxtLayout>
      <CookieBar v-if="brandName" :brand-name="brandName" />
      <VueQueryDevtools />
    </div>
  </div>
</template>
